export default {
  computed: {
    desktop() {
      return (this.$mq === "m992") || (this.$mq === "m1200")
    }
  },
}